import { SEARCH_CLEAR, SEARCH_CLEAR_ERROR, SEARCH_CLEAR_SUCCESS } from '@fogia/core-web/state/models/Search/constants';
import store from '@fogia/core-web/state/store';
import getQueryParams from '@fogia/core-web/utils/getQueryParams';

export const clear = (history, location) => (dispatch) => {
    dispatch({ type: SEARCH_CLEAR });
    try {
        const params = getQueryParams(location);
        delete params.search;
        history.replace(
            `?${Object.entries(params)
                .map((q) => q.join('='))
                .join('&')}`,
        );

        dispatch({ type: SEARCH_CLEAR_SUCCESS });
    } catch (e) {
        dispatch({ type: SEARCH_CLEAR_ERROR });
        throw e;
    }
};

export default (history, location) => store.dispatch(clear(history, location));
